<template>
  <div class="results-list_container width-responsiveness">
    <table class="apoio-datatable white-head">
      <colgroup>
        <col class="column-check">
        <col class="column-patient-name">
        <col class="column-exams-quantity">
        <col class="column-export">
        <col class="column-info">
      </colgroup>
      <thead>
        <tr>
          <th class="column-check">
            <div class="styled-checkbox">
              <input
                id="chkResultsSelectAll"
                v-model="selectAll"
                type="checkbox"
              >
              <label for="chkResultsSelectAll" />
            </div>
            <md-tooltip
              md-delay="400"
              md-direction="right"
            >
              Selecionar todos
            </md-tooltip>
          </th>
          <th
            title="PACIENTE (ID LIS)"
            class="sort-column"
            @click.prevent="sortColumn('patientName')"
          >
            PACIENTE (ID LIS) <sort-column id="patientName" />
          </th>
          <th class="column-exams-quantity">
            <span
              title="QTD. EXAMES PRONTOS"
              class="sort-column"
            >QTD. EXAMES PRONTOS</span>
          </th>
          <th class="column-export">
            EXPORTAR
          </th>
          <th />
        </tr>
      </thead>
    </table>

    <table class="apoio-datatable apoio-datatable-alt">
      <colgroup>
        <col class="column-check">
        <col class="column-patient-name">
        <col class="column-exams-quantity">
        <col class="column-export">
        <col class="column-info">
      </colgroup>
      <tbody
        v-for="resultsGroupedByName in resultsGroupedByNames"
        :key="resultsGroupedByName[0].id"
        :md-item="resultsGroupedByName"
      >
        <tr
          class="apoio-datatable__line apoio-datatable-alt"
          @click="openResultDetails(resultsGroupedByName[0].patientName)"
        >
          <td class="column-check" />
          <td>
            <span
              :title="resultsGroupedByName[0].patientName"
              class="patient-name-span"
            >
              {{ concatNameCode(resultsGroupedByName[0].patientName, resultsGroupedByName[0].patientIdLis) }}
            </span>
          </td>
          <td class="column-exams-quantity">
            {{ resultsGroupedByName.length }}
          </td>
          <td class="column-export">
            <button
              class="btn btn-primary btn-inline"
              @click.stop="exportPatientResults(resultsGroupedByName)"
            >
              <md-tooltip
                md-delay="400"
                md-direction="top"
              >
                Exportar resultados prontos desse paciente
              </md-tooltip>
              <md-icon
                md-src="/static/images/icon-download-arrow.svg"
                class="icon-download"
              >
                send
              </md-icon>Exportar
            </button>
          </td>
          <td>
            <div
              class="status-icon icon-arrow-dropdown-alt"
              @click.native="openResultDetails(resultsGroupedByName[0].patientName)"
            >
              <md-tooltip
                md-delay="400"
                md-direction="top"
              >
                Detalhes
              </md-tooltip>
            </div>
          </td>
        </tr>
        <tr
          v-if="resultsGroupedByName[0].expanded"
          class="row-details-alt"
        >
          <td
            class="row-details-alt__container"
            colspan="5"
          >
            <results-details :results-child="resultsGroupedByName" />
          </td>
        </tr>
      </tbody>

      <tfoot v-if="resultLoadingStatus !== 'STATUS_END'">
        <tr>
          <td colspan="5">
            <infinite-loading
              ref="infiniteLoading"
              @infinite="onInfinite"
            >
              <span slot="no-more" />
              <span slot="no-results" />
              <span slot="spinner">
                <spinner />
              </span>
            </infinite-loading>
          </td>
        </tr>
        <tr
          v-if="totalResults >= 1000"
          class="on-finite__message-container"
        >
          <td colspan="5">
            <loading-infinite-message
              :break-loading="breakResultsLoading"
              :update-status-count="getTotalResults"
            />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/common/Spinner'
import SortColumn from '@/components/common/SortColumn'
import loadingInfiniteMessage from '@/components/common/LoadingInfiniteMessage'
import { concatNameAndCode } from '@/utils/string-utils'
import { setSortation } from '@/utils/sort-columns'
import { mapActions, mapGetters } from 'vuex'
import resultsDetails from './ResultsDetails'
import mixin from './resultMixin'

export default {
  name: 'ResultsList',
  components: {
    'infinite-loading': InfiniteLoading,
    'spinner': Spinner,
    'sort-column': SortColumn,
    'loading-infinite-message': loadingInfiniteMessage,
    'results-details': resultsDetails
  },
  mixins: [mixin],
  data: () => ({
    columnSortStatusResults: {
      patientName: 'asc',
      examsQuantity: 'asc'
    }
  }),
  methods: {
    ...mapActions([
      'getServiceResult',
      'setWaitingResultLoadingStatus',
      'clearAllResultData',
      'sortResultList',
      'getTotalResults',
      'breakResultsLoading',
      'openResultDetails',
      'xmlResults'
    ]),
    sortColumn (column, columnChild) {
      this.columnSortStatusResults[column] = setSortation(column, columnChild, this.columnSortStatusResults, this.sortResultList)
      this.submitEventToAnalytics('Ordenação da coluna ' + column)
    },
    onInfinite () {
      this.getTotalResults()
      this.getServiceResult()
    },
    concatNameCode (name, code) {
      return concatNameAndCode(name, code)
    },
    exportPatientResults (patient) {
      var selected = []
      patient.forEach(function (patient) {
        selected.push(patient.id)
      })
      this.xmlResults(selected).then((downloadLink) => {
        if (downloadLink) {
          document.body.appendChild(downloadLink)
          downloadLink.click()
          this.clearAllResultData()
          this.submitEventToAnalytics({ action: 'Exportar Resultado in-line', label: selected.length })
        }
      })
    },
    submitEventToAnalytics ({action, label}) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'Resultados - Listagem',
        'action': action,
        'label': label,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  },
  computed: {
    ...mapGetters([
      'resultsGroupedByNames',
      'resultLoadingStatus',
      'totalResults',
      'profile'
    ])
  },
  watch: {
    resultLoadingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_END':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_SUCCESS':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          this.setWaitingResultLoadingStatus()
          break
        case 'STATUS_FAILED':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_INITIAL':
          this.clearAllResultData()
          this.selected = []
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
          }
          break
        case 'STATUS_WAITING':
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/mixins';

  .results-list_container {
    margin-top: 20px;

    .apoio-datatable {
      &__line {
        height:56px;
        cursor: pointer;
      }
    }

    .styled-checkbox input[type="checkbox"]:checked + label {
      background-color: #691043;
      border: 1px solid #691043;
    }

    .styled-checkbox input[type="checkbox"]:active + label:active {
      border: 1px solid #691043;
    }

    .column-check {
      width: 45px;
      padding: 0 0 0 24px;
    }

    .column-exams-quantity {
      text-align: center;
      width: 25%;
    }

    .column-export {
      text-align: center;
    }

    .column-patient-name {
      width: 25%;
    }

    .column-info {
      width: 60px;
      padding: 0 24px 0 0;
    }
    @media screen and (min-width:0\0) {
  .styled-checkbox {
    label {
      border: none;
      box-shadow: none;

      &:after {
        display: none;
      }

      &:hover::after {
        opacity: 1;
      }
    }

    input[type=checkbox] {
      border: none;
      box-shadow: none;
      opacity: 1;

      &:checked + label {
        background-color: inherit;
        border: none;

        &:after {
          opacity: 1;
        }
      }

      &:focus + label {
        border: none;
        box-shadow: none;
      }
    }
  }
}

    .sort-icon {
      position: relative;
    }

    .apoio-datatable {
      margin-top: 0;
    }

    .tooltip-size{
      width: 20px;
    }
  }

  .results-main-view {
    &__icon {
      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
      font-size: 20px;
      margin-right: 6px;
    }
  }
</style>
